module.exports = __webpack_public_path__ + "assets/img/110e-ie.svg";